import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';

export const dialog: Dialog[] = [
  {
    id: 'start',
    type: DialogType.description,
    text: 'A man stands by an empty cottage, cutting fresh marks into a tally stick. He sees you, tucks it into his belt, and waves you over.',
    options: [
      { text: 'Go to him.', nextDialogId: 'greet' },
      { text: 'Look over the empty house first.', nextDialogId: 'house' },
    ],
  },
  {
    id: 'house',
    type: DialogType.description,
    text: 'The cottage sits shut and quiet. The hearth is cold, and the garden behind it has gone to weeds. No one has lived here for a year or more. The man watches you look, then speaks.',
    options: [{ text: '(Turn to him.)', nextDialogId: 'greet' }],
  },
  {
    id: 'greet',
    type: DialogType.dialog,
    text: "I am the reeve here, the lord's man in Beggen. Houses and tenants are my charge. You have the look of someone who needs a roof, and here one stands with no one in it.",
    options: [
      { text: 'Why does it stand empty?', nextDialogId: 'empty' },
      { text: 'You would give me a house?', nextDialogId: 'offer' },
    ],
  },
  {
    id: 'empty',
    type: DialogType.dialog,
    text: 'The family that held it is dead. The sickness took them last year, and half the village with them. My lord of Sankt Johannisberg has more empty houses now than people to fill them.',
    options: [{ text: 'And you would put me in one?', nextDialogId: 'offer' }],
  },
  {
    id: 'offer',
    type: DialogType.dialog,
    text: 'Then take this **house**. You would hold it from the lord, not own it. Four walls, a door that shuts, and the garden plot behind. It is more than you have now.',
    options: [
      { text: 'What must I pay?', nextDialogId: 'terms' },
      { text: 'I need time to think.', nextDialogId: 'notyet' },
    ],
  },
  {
    id: 'terms',
    type: DialogType.dialog,
    text: 'A small sum to take it up, then a little rent each year. **Two sous** now, and two sous each autumn after. In fatter years I would ask more, but the lord wants the house lived in.',
    options: [
      { text: 'I will take it.', nextDialogId: 'accept' },
      { text: 'It is still much for me.', nextDialogId: 'haggle' },
    ],
  },
  {
    id: 'haggle',
    type: DialogType.dialog,
    text: 'The plague has left me more houses than takers, so I will not press you hard. One sou now, then. The rest can wait until your first harvest is in.',
    options: [
      { text: 'Then I will take it.', nextDialogId: 'accept' },
      { text: 'Not yet.', nextDialogId: 'notyet' },
    ],
  },
  {
    id: 'accept',
    type: DialogType.dialog,
    // TODO: a tenancy/holding is not yet an engine feature. When it exists, this
    // node should (a) take the entry fine from the player's coins and (b) mark the
    // player as the lord's tenant (grant the holding). A consume-coins effect
    // already exists in the model ({ type: 'consume', item: 'coins', quantity: N },
    // as used by the merchant), so the entry fine could hook in here as e.g.
    //   effects: [{ type: 'consume', item: 'coins', quantity: 24 /* 2 sous */ }, <grant holding>],
    // BUT do not wire the consume alone: the tree loops back to 'start' and there
    // is no holding flag to guard re-entry, so re-accepting would drain coins
    // repeatedly, and there is nothing to grant in return. Add tenancy state + an
    // affordability condition (see merchant's coins check) before enabling effects.
    text: 'Done. I cut your mark on the tally, and it is settled. Welcome to Beggen, tenant. The house is yours to live in, so long as the rent is paid to the lord.',
    options: [{ text: 'My thanks.', nextDialogId: 'start' }],
  },
  {
    id: 'notyet',
    type: DialogType.dialog,
    text: 'As you like. The house will keep a while yet. But the land does not wait forever, and a roof is a roof. Come find me when you have thought it over.',
    options: [{ text: 'I will.', nextDialogId: 'start' }],
  },
];
